<script>
    import {actionsNotificationStore, hideActionNotification} from "./actions-store.js";
    import { t } from '../../core/i18n/language-store';

    function clickHandler() {
        hideActionNotification();
    }
</script>

<style>

    .action-notification-container {
        position: fixed;
        z-index: 1000;
        left: 0;
        right: 0;
        top: 1rem;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .action-notification {
        background: var(--action-notif-default-bg);
        color: var(--action-notif-default-text);
        padding: .5rem 1rem;
        border-top-left-radius: 4px;
        border-bottom-right-radius: 4px;
        box-shadow: 0 4px 12px 0 rgba(0,0,0,0.25);
        gap: 10px;
        opacity: 1;
        transition: opacity .3s ease;
        max-width: 90%;
        animation: slide-down .2s ease-out forwards;
    }
    @keyframes slide-down {
        from {transform: translateY(-100%);}
        to {transform: translateY(0);}
    }
    .action-notification--success {}
    .action-notification--error {
        background: var(--action-notif-error-bg);
        color: var(--action-notif-error-text);
    }

    #an-success, #an-error {
        display: none;
    }
    .action-notification--success #an-success {
        display: unset;
    }
    .action-notification--error #an-error {
        display: unset;
    }

</style>

{#if ($actionsNotificationStore.opened)}
<div class="action-notification-container">

    <div class="action-notification flex ai-center can-fade-out"
         class:fade-out={$actionsNotificationStore.closing}
         class:action-notification--success={$actionsNotificationStore.type === 'success'}
         class:action-notification--error={$actionsNotificationStore.type === 'error'}
         on:click={() => clickHandler()}>

        <svg id="an-success" width="1em" height="1em" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.68 4.54333C4.484 4.74333 4.28133 4.89933 4.08333 5.01667V13.2393L9.756 14.0547C10.4117 14.1502 11.0798 14.0042 11.636 13.644C12.1975 13.2793 12.6121 12.728 12.8067 12.0873L13.982 8.252C14.086 7.91142 14.1102 7.55146 14.0528 7.20001C13.9953 6.84856 13.8577 6.51506 13.6507 6.22533C13.4451 5.93913 13.1749 5.70547 12.862 5.54333C12.5509 5.38291 12.206 5.29903 11.856 5.29867H9.434C9.57878 4.93047 9.68947 4.54976 9.76467 4.16133C9.83721 3.78656 9.87382 3.40573 9.874 3.024C9.874 2.42133 9.63933 1.84267 9.22133 1.416C8.804 0.99 8.23733 0.75 7.64667 0.75C7.056 0.75 6.48933 0.99 6.072 1.41667C5.65298 1.84671 5.41875 2.42357 5.41933 3.024C5.41933 3.422 5.20333 4.00867 4.68 4.54333ZM3.55 4.08333H1.28333C1.14188 4.08333 1.00623 4.13952 0.90621 4.23954C0.80619 4.33956 0.75 4.47522 0.75 4.61667V13.55C0.75 13.6914 0.80619 13.8271 0.90621 13.9271C1.00623 14.0271 1.14188 14.0833 1.28333 14.0833H3.55C3.69145 14.0833 3.8271 14.0271 3.92712 13.9271C4.02714 13.8271 4.08333 13.6914 4.08333 13.55V4.61667C4.08333 4.47522 4.02714 4.33956 3.92712 4.23954C3.8271 4.13952 3.69145 4.08333 3.55 4.08333Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linejoin="round"/>
        </svg>

        <svg id="an-error" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 10H9.01M15 10H15.01M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z" stroke="#F08282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.5 15.25C9.82588 14.9174 10.2148 14.6532 10.6441 14.4728C11.0734 14.2924 11.5344 14.1995 12 14.1995C12.4656 14.1995 12.9266 14.2924 13.3559 14.4728C13.7852 14.6532 14.1741 14.9174 14.5 15.25" stroke="#F08282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        <div>{$actionsNotificationStore.message}</div>
    </div>

</div>
{/if}
